import {Component, Input, OnInit} from '@angular/core';
import StsA360RegistrationResponseModel
  from '../../../models/sts-a360-registration-response.model';
import {StsNotification} from '../../../models/sts-notification.model';
import {StsNotificationType} from '../../../models/sts-notification-type';
import {Router} from '@angular/router';
import {StsRegistrationType} from '../../../models/sts-registration-type.enum';
import { StsCmsService } from 'app/services/sts-cms-service.service';
import {StsA360RegServicesService} from '../../../services/sts-a360-reg-services.service';
import StsA360NotificationTokenModel from 'app/models/sts-a360-notification-token.model';
import { Observable } from 'rxjs';
import StsA360RegStep2UsernamePostModel from '../../../models/sts-a360-reg-step2-username-post.model';
import { StsUser } from "../../../models/sts-user.model";
import { StsTfaRegServiceService } from '../../../services/sts-tfa-reg-service.service';
import { StsTenantService } from '../../../services/sts-tenant.service';
import { StsTenant } from '../../../models/sts-tenant.model';

@Component({
  selector: 'app-account-reg-identity-questions',
  templateUrl: './account-reg-identity-questions.component.html',
  styleUrls: ['./account-reg-identity-questions.component.scss']
})
export class AccountRegIdentityQuestionsComponent implements OnInit {

  public errors: StsNotification[] = [];
  public mode: StsRegistrationType = StsRegistrationType.Registration;
  public tokenSubscription: Observable<StsA360NotificationTokenModel>=null;
  public tenantInfo: StsTenant = new StsTenant();
  message: StsA360NotificationTokenModel;
  id: string;

  constructor(private router: Router, private regService: StsA360RegServicesService, private cmsService: StsCmsService,
    private tfa: StsTfaRegServiceService,
    private tenantService: StsTenantService) {
    this.tenantService.getTenantSource().subscribe(tenant => {
      this.tenantInfo = tenant;
    });
  }

  ngOnInit() {
    this.regService.currentMessage.subscribe(message => this.message = message)
  }



  onSuccess(rsp: StsA360RegistrationResponseModel): void {
    this.errors = [];
    if (rsp.success) {
      this.id = rsp.info.id;

      if (rsp.info.hasActiveOtc || rsp.info.otcGenerated) {
        this.otcFlow(rsp, false);
      } else {
        this.otcFlow(rsp, true);
      }
    } else {
      if (rsp.errors.length) {
        for (let ei = 0; ei < rsp.errors.length; ei++) {
          let err = new StsNotification();
          err.code = 'sts-registration-invalid';
          err.level = StsNotificationType.Error;
          err.description = 'sts-registration-invalid';
          this.errors.push(err);
        }
      } else if (rsp.info && rsp.info.errorCode) {
        if (rsp.info.errorCode === 'incorrectpostalcode') {
          let url = '/account/wrong-postal-code';
          //if otc flow
          if (rsp.info.hasActiveOtc || rsp.info.otcGenerated) {
            this.otcFlow(rsp, false);
          }
          else {
            this.message.ID = rsp.info.id;
            this.message.NotificationID = rsp.info.notificationID;
            this.message.ContactId = rsp.info.contactId;
            this.regService.changeMessage(this.message);
            this.router.navigateByUrl(url);
          }
        }
        else {
          let err = new StsNotification();
          err.code = rsp.info.errorCode;
          if (err.code.match(/^sts-/ig) == null) {
            err.code = `sts-reg-error-${err.code}`;
          }
          err.level = StsNotificationType.Error;
          err.description = rsp.info.errorCode;
          this.errors.push(err);
        }
      } else {
        let e = new StsNotification();
        e.code = rsp['sts-code'] || rsp['stsCode'];
        e.level = StsNotificationType.Error;
        e.description = 'unexpected';
        this.errors.push(e);
      }

    }
  }

  gotoHome(mode: StsRegistrationType): void {
    this.router.navigateByUrl('/');
  }

  showErrors(errs: StsNotification[]): void {
    this.errors = errs;
  }

  registerUser(email: string, useEmailOnFileForRegistration: boolean): void {
    this.message.AllowUsernameAsUniqueId = true;

    if (useEmailOnFileForRegistration) {
      if (email) {
        let n = new StsA360RegStep2UsernamePostModel();
        n.id = this.id;
        let user = new StsUser();
        user.id = n.id;
        n.email = email;
        this.regService.postStep2Answers(n).subscribe(rs => {
          if (rs.success) {
            //Check for Lexis Nexis Failue and redirect to contact-support
            
            //tenant has 2fa
            if (this.tenantInfo.isTfaEnabled) {
              this.tfa.sendValidationEmail(
                this.tenantInfo.tfaPreferredMode, n.email).subscribe(a => {
                  if (a.success) {
                    let url = '/account/validate/email/' + user.id;
                    this.router.navigateByUrl(url);
                  } else {
                    if (this.message.PreferredChannel === 'email' || this.message.PreferredChannel === 'personalemail') {
                      let e = new StsNotification();
                      e.code =  a.stsCode || 'sts-failed-tfa-email';
                      e.level = StsNotificationType.Error;
                      e.description = 'An error occurred while validating your email';
                      this.errors = [e];
                    }
                    else {
                      if (this.message.PreferredChannel == "phone") {
                        let e = new StsNotification();
                        e.code = a.stsCode || 'sts-failed-tfa-email-phone';
                        e.level = StsNotificationType.Error;
                        e.description = 'an error occured while validating your phone';
                        this.errors = [e];
                      }
                      else {
                        let e = new StsNotification();
                        e.code = rs['sts-code'] || a.stsCode;
                        e.level = StsNotificationType.Error;
                        e.description = 'Submitted data contains errors';
                        this.errors = [e];
                      }
                    }
                  }
                });
            } else {
              this.router.navigate(['/account/password/new', { id: user.id }]);
            }
          } else {
            let e = new StsNotification();
            e.code = rs['sts-code'] || rs.stsCode;
            e.level = StsNotificationType.Error;
            e.description = 'Submitted data contains errors';

            if (e.code === 'sts-invalid-email'
              && (this.message.PreferredChannel === 'email' || this.message.PreferredChannel === 'personalemail')
              && !this.message.Email
              && !this.message.PersonalEmail
              && this.message.Phone
            )
            {
              e.code = "STS_LOGIN_FAILED";
            }

            this.errors = [e];
          }
        });
      } else {//TODO: need a wording for the resource
        this.setError('sts-missing-email-on-file', StsNotificationType.Error, 'we dont have your email on file, please contact Administrator');
      }
    } else {
      let url = '/account/reg-step-2/' + this.id + '/false/false';
      this.router.navigateByUrl(url);
    }
  }

  otcFlow(rsp: StsA360RegistrationResponseModel, enforceEmail:boolean): void {
    let url = '';
    this.message.ID = rsp.info.id;
    this.message.NotificationID = rsp.info.notificationID;
    this.message.PersonalEmail = rsp.info.personalEmail;
    this.message.Email = rsp.info.email;
    this.message.Phone = rsp.info.phone;
    this.message.ContactId = rsp.info.contactId;
    this.message.EnableLexisNexisIntegration = rsp.enableLexisNexisIntegration;

    //fOr backward compatibility. Check if IsUseEmailOnFileForRegistrationEnabled is returned
    if(this.tenantInfo.isUseEmailOnFileForRegistrationEnabled == undefined) {
      this.tenantInfo.isUseEmailOnFileForRegistrationEnabled = rsp.useEmailOnFileForRegistration;
    }

    // if otc flow
    if (rsp.info.hasActiveOtc && !enforceEmail) {
      url = '/account/reg/verify-otc/' + rsp.info.id;
    }
    //otc is expired/consumed/exceeded    
    else if (rsp.info.otcGenerated == true || enforceEmail) {
      //both channels are defined for the contact
      if ((rsp.info.email || rsp.info.personalEmail) && rsp.info.phone) {
        //2 channels are defined for the tenant
        if(this.tenantInfo.tfaDeliveryChannels.length > 1 && this.tenantInfo.tfaDeliveryChannels.includes('SMS')){
          url = '/account/reg/sel-comm/' + rsp.info.id;
        }
        //tenant has 1 channel - must be an email - then use the email
        else {
          this.message.PreferredChannel = "email";
          this.regService.changeMessage(this.message);
          this.registerUser(rsp.info.personalEmail, this.tenantInfo.isUseEmailOnFileForRegistrationEnabled);
          return;
        }
      }
      //none of the channels defined for the contact
      else if (!(rsp.info.email || rsp.info.personalEmail || rsp.info.phone)) {
        //Check if Email Collection is enabled
        let isEmailCollectionEnabled = !this.tenantInfo.isUseEmailOnFileForRegistrationEnabled
          && this.tenantInfo.isEmailCollectionEnabled;
        if (this.message.EnableLexisNexisIntegration || (isEmailCollectionEnabled || (!this.tenantInfo.isTfaEnabled && !this.tenantInfo.isUseEmailOnFileForRegistrationEnabled))) {
          //go to step 2 (Set up your user ID)
          this.registerUser(rsp.info.personalEmail, false);
          return;
        }
        else{
          let err = new StsNotification();
          err.code = 'sts-otc-invalid-system';
          err.level = StsNotificationType.Error;
          err.description = 'You do not have a valid one-time code in our system. Please contacted the Call Centre';
          this.errors.push(err);
          return;
        }
        
      }
      //one of the channels is defined for the contact
      else {
        if (rsp.info.phone) {
          if (this.tenantInfo.tfaDeliveryChannels.length > 1) {
            this.message.PreferredChannel = this.tenantInfo.tfaDeliveryChannels.includes('SMS')
              ? 'phone'
              : this.tenantInfo.tfaPreferredMode;
            this.regService.changeMessage(this.message);
            //Even for phone on file we will try to collent Email Address and use that as the User Id
            if(this.message.EnableLexisNexisIntegration || (!this.tenantInfo.isUseEmailOnFileForRegistrationEnabled && this.tenantInfo.isEmailCollectionEnabled)){
              this.registerUser(rsp.info.personalEmail, false);
              return;
            }
            else{
              //This will always throw an error for EAS because email validation will fail            
              this.registerUser(rsp.info.phone, this.tenantInfo.isUseEmailOnFileForRegistrationEnabled);
              return;
            }
            
          }
          //only 1 tenant channel - so it is an email and this contact only has phone
          else {
            //Check if Email Collection is enabled
            let isEmailCollectionEnabled = !this.tenantInfo.isUseEmailOnFileForRegistrationEnabled
              && this.tenantInfo.isEmailCollectionEnabled;
            if (this.message.EnableLexisNexisIntegration || (isEmailCollectionEnabled || (!this.tenantInfo.isTfaEnabled && !this.tenantInfo.isUseEmailOnFileForRegistrationEnabled))) {
              //go to step 2 (Set up your user ID)
              this.registerUser(rsp.info.personalEmail, false);
              return;
            }
            else{
              let err = new StsNotification();
              err.code = 'sts-otc-invalid-system';
              err.level = StsNotificationType.Error;
              err.description = 'You do not have a valid one-time code in our system. Please contacted the Call Centre';
              this.errors.push(err);
              return;
            }
            
          }
        }
        //tenant has 1 or 2 channels, contact has only email - then use email
        else {
          this.message.PreferredChannel = "email";
          this.regService.changeMessage(this.message);
          this.registerUser(rsp.info.personalEmail, this.tenantInfo.isUseEmailOnFileForRegistrationEnabled);
          return;
        }
      }
    }

    if (!this.message.PreferredChannel)
      this.message.PreferredChannel = "email";

    this.regService.changeMessage(this.message);

    this.router.navigateByUrl(url);
  }

  setError(code: string, level: StsNotificationType, descr: string): void {
    let err = new StsNotification();
    err.code = code;
    err.level = level;
    err.description = descr;
    this.errors.push(err);
  }
}
